const UNIX_SECONDS_TO_MS = 1000;

export const getReleaseYear = (firstReleaseDate?: number): number | null => {
  if (!firstReleaseDate) {
    return null;
  }

  return new Date(firstReleaseDate * UNIX_SECONDS_TO_MS).getFullYear();
};
